import SendCodePage from "./SendCodePage";

export default SendCodePage;